 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"playOff":"playOff","matchInfo":"matchInfo","tournamentInfo":"tournamentInfo","tournamentPage":"tournamentPage","groupstageList":"groupstageList","matchFeed":"matchFeed","tournamentBrackets":"tournamentBrackets","tournamentMatches":"tournamentMatches","tournamentNews":"tournamentNews","tournamentRules":"tournamentRules","tournamentStatistics":"tournamentStatistics","tournamentTeams":"tournamentTeams","tournamentVideos":"tournamentVideos","tournamentWinners":"tournamentWinners"}[chunkId]||chunkId) + "." + {"chunk-0765dc10":"0d014121","chunk-116fcee8":"5c3cf544","chunk-13522a37":"90f756f3","chunk-28b25647":"ad8769ce","chunk-2d0aa1e7":"e4546354","chunk-2d0d2bc3":"bd5352a5","chunk-797b5a09":"e7b9b5c6","playOff":"7f42c569","chunk-2d0e97b4":"dde4c1bd","chunk-6725f825":"4109c9e6","chunk-9ef027aa":"56568301","chunk-7f2defa5":"ab410efe","chunk-0edce503":"2b8f0f0b","chunk-a089e450":"45ae07fb","chunk-dd88f9f8":"9cbececd","chunk-2d2245c1":"c0cbbd0c","chunk-1301f7cc":"f9154eb9","matchInfo":"eb26f8b6","chunk-4bd3159a":"8f857d50","chunk-50b5adf2":"0bfa6fb3","chunk-5a44b69a":"6ffb492e","chunk-639be678":"06b397b9","chunk-1a7fbbe6":"345fafd9","tournamentInfo":"3ccb156d","tournamentPage":"d133fbc6","groupstageList":"648b94d3","matchFeed":"332c09ba","tournamentBrackets":"6f922246","tournamentMatches":"b944c93c","tournamentNews":"c652b266","tournamentRules":"f19d6456","tournamentStatistics":"338c0d47","tournamentTeams":"7f1ee8ac","tournamentVideos":"9e3e7fcd","tournamentWinners":"e2bdc210"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-0765dc10":1,"chunk-116fcee8":1,"chunk-13522a37":1,"chunk-28b25647":1,"chunk-797b5a09":1,"playOff":1,"chunk-6725f825":1,"chunk-7f2defa5":1,"chunk-0edce503":1,"chunk-a089e450":1,"chunk-dd88f9f8":1,"chunk-1301f7cc":1,"matchInfo":1,"chunk-4bd3159a":1,"chunk-50b5adf2":1,"chunk-639be678":1,"chunk-1a7fbbe6":1,"tournamentInfo":1,"tournamentPage":1,"groupstageList":1,"tournamentBrackets":1,"tournamentMatches":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"playOff":"playOff","matchInfo":"matchInfo","tournamentInfo":"tournamentInfo","tournamentPage":"tournamentPage","groupstageList":"groupstageList","matchFeed":"matchFeed","tournamentBrackets":"tournamentBrackets","tournamentMatches":"tournamentMatches","tournamentNews":"tournamentNews","tournamentRules":"tournamentRules","tournamentStatistics":"tournamentStatistics","tournamentTeams":"tournamentTeams","tournamentVideos":"tournamentVideos","tournamentWinners":"tournamentWinners"}[chunkId]||chunkId) + "." + {"chunk-0765dc10":"febbac3d","chunk-116fcee8":"76a97400","chunk-13522a37":"763cd816","chunk-28b25647":"64570cf7","chunk-2d0aa1e7":"31d6cfe0","chunk-2d0d2bc3":"31d6cfe0","chunk-797b5a09":"768201d7","playOff":"6ba9d68c","chunk-2d0e97b4":"31d6cfe0","chunk-6725f825":"a0e361c8","chunk-9ef027aa":"31d6cfe0","chunk-7f2defa5":"fb342c5c","chunk-0edce503":"6b09c2ec","chunk-a089e450":"1742062f","chunk-dd88f9f8":"0954aa81","chunk-2d2245c1":"31d6cfe0","chunk-1301f7cc":"d03c3267","matchInfo":"ee681908","chunk-4bd3159a":"274c2391","chunk-50b5adf2":"d8ed0750","chunk-5a44b69a":"31d6cfe0","chunk-639be678":"2e98d360","chunk-1a7fbbe6":"73211fc5","tournamentInfo":"c8e31240","tournamentPage":"5ab16a6d","groupstageList":"e0482855","matchFeed":"31d6cfe0","tournamentBrackets":"a3769fe7","tournamentMatches":"c1f075e0","tournamentNews":"31d6cfe0","tournamentRules":"31d6cfe0","tournamentStatistics":"31d6cfe0","tournamentTeams":"31d6cfe0","tournamentVideos":"31d6cfe0","tournamentWinners":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
